export default "__VITE_ASSET__BqMpjHUk__"